var openQuickView = function openQuickView(targetId) {
  document.querySelector(targetId).querySelector('.sizechart-js').classList.remove('opened');
  document.querySelector('#quick-view-overlay-js').classList.add('opened');
  document.querySelector(targetId).classList.add('opened');
};
var closeQuickView = function closeQuickView(targetId) {
  document.querySelector(targetId).querySelector('.sizechart-js').classList.remove('opened');
  document.querySelector('#quick-view-overlay-js').classList.remove('opened');
  document.querySelector(targetId).classList.remove('opened');
};
/**
 * The `initQuickView` function sets up event listeners for opening and closing quick view elements
 * based on button clicks.
 */
var initQuickView = function initQuickView() {
  var btnOpenQuickView = document.querySelectorAll('.quick-view-open-js');
  var btnCloseQuickView = document.querySelectorAll('.quick-view-close-js');
  var overlayQuickView = document.querySelector('#quick-view-overlay-js');
  if (!overlayQuickView) {
    return;
  }
  overlayQuickView.addEventListener('click', function () {
    document.querySelectorAll('.quick-view.opened').forEach(function (item) {
      item.classList.toggle('opened');
    });
    overlayQuickView.classList.toggle('opened');
  });
  btnOpenQuickView.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var id = e.target.dataset.id;
      openQuickView("#quick-view-".concat(id));
    });
  });
  btnCloseQuickView.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var id = e.target.closest('.quick-view-close-js').dataset.id;
      closeQuickView("#quick-view-".concat(id));
    });
  });
};
export { initQuickView };